class AdpSubnavigationController {
  constructor() {
    this.name = 'adpSubnavigation';
  }
}

export default AdpSubnavigationController;



// WEBPACK FOOTER //
// ./src/app/components/adpSubnavigation/adpSubnavigation.controller.js